export const Equalizer = ({ active = true, className = "" }) => (
  <span className={`eq ${active ? "eq-on" : ""} ${className}`} aria-hidden="true">
    <i /><i /><i /><i />
  </span>
);

export const LiveBadge = ({ label = "EN VIVO" }) => (
  <span data-testid="live-badge" className="inline-flex items-center gap-2 font-mono text-[11px] font-medium tracking-[0.2em] text-white">
    <span className="relative flex h-2.5 w-2.5">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#FF4500] opacity-75" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#FF4500]" />
    </span>
    {label}
  </span>
);
